export default "__VITE_ASSET__529d5017__"